import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import { Input } from "@shared/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
import { useCreatedUserNames } from "@features/onboarding/utility-setup/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { onboardingApi } from "@features/onboarding/utility-setup/api";
import { tarrifFilters } from "../types";
import { useRateTypes } from "../hooks";

// interface ExtendedTarrifFilters extends tarrifFilters {
//   createdBy?: string;
// }

interface FilterPanelProps {
  currentFilters: tarrifFilters;
  onApplyFilters: (filters: tarrifFilters) => void;
  onResetFilters: () => void;
}

interface UserSearchResult {
  id: number;
  utility: number;
  utility_id: number;
  role_code: string[];
  gender: string;
  slug: string;
  user: {
    id: number;
    email: string;
    createdBy: string;
    name: string;
    isActive: boolean;
    lastLogin: string | null;
    createdDate: string;
    tncAccepted: boolean;
  };
  extraData_map: {
    department: string;
  };
  isSetupCompleted: boolean;
  status: string;
}

// Custom hook for user search
const useUserSearch = (remoteUtilityId: string) => {
  // const [users, setUsers] = useState<any[]>([]);
  // const [isLoading, setIsLoading] = useState(false);

  // const searchUsers = async (searchTerm: string) => {
  //   if (searchTerm.length < 3) {
  //     setUsers([]);
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     // Using your existing onboardingApi
  //     const response = await onboardingApi.getCreatedUsers(
  //       remoteUtilityId,
  //       searchTerm
  //     );
  //     setUsers(response);
  //   } catch (error) {
  //     console.error("Error searching users:", error);
  //     setUsers([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // return { users, isLoading, searchUsers };
};

// User Search Autocomplete Component
interface UserSearchProps {
  value: string;
  onChange: (value: string) => void;
  remoteUtilityId: string;
}

const UserSearchAutocomplete: React.FC<UserSearchProps> = ({
  value,
  onChange,
  remoteUtilityId,
}) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const [isOpen, setIsOpen] = useState(false);
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(
    null
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // const { users, isLoading, searchUsers } = useUserSearch(remoteUtilityId);
  // Debounced search
  // useEffect(() => {
  //   if (debounceTimer) {
  //     clearTimeout(debounceTimer);
  //   }

  //   const timer = setTimeout(() => {
  //     searchUsers(searchTerm);
  //   }, 300);

  //   setDebounceTimer(timer);

  //   return () => {
  //     if (debounceTimer) {
  //       clearTimeout(debounceTimer);
  //     }
  //   };
  // }, [searchTerm]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchTerm(newValue);
    setIsOpen(newValue.length >= 3);

    // If user clears the input, also clear the selected value
    if (newValue === "") {
      onChange("");
    }
  };

  const handleUserSelect = (user: UserSearchResult) => {
    setSearchTerm(user.user.name);
    onChange(user.user.name);
    setIsOpen(false);
  };

  const handleInputFocus = () => {
    if (searchTerm.length >= 3) {
      setIsOpen(true);
    }
  };

  return (
    <div className="relative">
      <Input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        placeholder="Search by user name (min 3 characters)"
        className="w-full"
      />

      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto"
        >
          {/* {isLoading ? (
            <div className="px-3 py-2 text-sm text-gray-500">
              Searching users...
            </div>
          ) : users.length > 0 ? (
            users.map((user) => (
              <button
                key={user.id}
                type="button"
                onClick={() => handleUserSelect(user)}
                className="w-full px-3 py-2 text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
              >
                <div className="text-sm font-medium">
                  {user.createdUserRemoteName}
                </div>
                <div className="text-xs text-gray-500">
                  {user.createdUserRemoteName}
                </div>
              </button>
            ))
          ) : searchTerm.length >= 3 ? (
            <div className="px-3 py-2 text-sm text-gray-500">
              No users found
            </div>
          ) : null} */}
        </div>
      )}
    </div>
  );
};

export const FilterPanel: React.FC<FilterPanelProps> = ({
  currentFilters,
  onApplyFilters,
  onResetFilters,
}) => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: activeUtilityServices, isLoading: loadingUtilityServices } =
    useActiveUtilityServices();

      const { data: userNames, isLoading: loadinguserNames } =
    useCreatedUserNames();

  const { data: rateTypes, isLoading: loadingRateTypes } = useRateTypes();

  const form = useForm({
    defaultValues: {
      utility_service: currentFilters.utilityService || "ALL_SERVICES",
      rate_type: currentFilters.rateType || "ALL_RATE_TYPES",
      user_name: currentFilters.createdBy || "",
    },
  });

  // Sync form values when currentFilters change
  useEffect(() => {
    form.setValue(
      "utility_service",
      currentFilters.utilityService || "ALL_SERVICES"
    );
    form.setValue("rate_type", currentFilters.rateType || "ALL_RATE_TYPES");
    form.setValue("user_name", currentFilters.createdBy || "");
  }, [currentFilters, form]);

  const handleApplyFilters = (data: any) => {
    const filtersToApply: Partial<tarrifFilters> = {};

    if (data.utility_service && data.utility_service !== "ALL_SERVICES") {
      filtersToApply.utilityService = data.utility_service;
    }

    if (data.rate_type && data.rate_type !== "ALL_RATE_TYPES") {
      filtersToApply.rateType = data.rate_type;
    }

    if (data.user_name && data.user_name.trim() !== "") {
      filtersToApply.createdBy = data.user_name.trim();
    }

    onApplyFilters(filtersToApply);
  };

  const handleResetFilters = () => {
    form.reset({
      utility_service: "ALL_SERVICES",
      rate_type: "ALL_RATE_TYPES",
      user_name: "",
    });
    onResetFilters();
  };

  return (
    <form onSubmit={form.handleSubmit(handleApplyFilters)}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* User Search */}
        {/* <div className="space-y-2">
          <Label>Search User</Label>
          <Controller
            name="user_name"
            control={form.control}
            render={({ field }) => (
              <UserSearchAutocomplete
                value={field.value}
                onChange={field.onChange}
                remoteUtilityId={remoteUtilityId}
              />
            )}
          />
        </div> */}

        <div className="space-y-2">
          <Label>User</Label>
          <Controller
            name="user_name"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select user" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {userNames?.map((user) => (
                      <SelectItem
                        key={user.createdUserRemoteName}
                        value={user.createdUserRemoteName}
                      >
                        {user.createdUserRemoteName}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
         
        </div>

        {/* Utility Service */}
        <div className="space-y-2">
          <Label>Utility Service</Label>
          <Controller
            name="utility_service"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select utility service" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_SERVICES">All Services</SelectItem>
                    {activeUtilityServices?.map((service) => (
                      <SelectItem key={service.name} value={service.name}>
                        {service.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
          {loadingUtilityServices && (
            <div className="text-xs text-gray-500">Loading services...</div>
          )}
        </div>

        {/* Rate Type */}
        <div className="space-y-2">
          <Label>Rate Type</Label>
          <Controller
            name="rate_type"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select rate type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_RATE_TYPES">
                      All Rate Types
                    </SelectItem>
                    {rateTypes?.map((rateType) => (
                      <SelectItem
                        key={rateType.key}
                        value={rateType.key.toString()}
                      >
                        {rateType.value}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
          {loadingRateTypes && (
            <div className="text-xs text-gray-500">Loading rate types...</div>
          )}
        </div>

        {/* Actions */}
        <div className="col-span-1 md:col-span-2 lg:col-span-3 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          <Button type="submit">Apply Filters</Button>
        </div>
      </div>
    </form>
  );
};
